module.exports = __webpack_public_path__ + "static/media/Pansear_gaussian2.88d0a079.png";